import MultiSelect from "./multiSelect";

export default MultiSelect;
